import * as THREE from 'three';
import { labelPlane, roundedBox } from '../materials/MaterialFactory';
import { markInteractive } from './BaseComponent';

export class LiPoBattery extends THREE.Group {
  constructor() {
    super();
    this.name = '3.7V 锂电池';
    const pouch = new THREE.Mesh(
      roundedBox(4.2, 2.65, 0.34, 0.2),
      new THREE.MeshStandardMaterial({ color: 0xb9c1c8, metalness: 0.75, roughness: 0.32 })
    );
    pouch.rotation.x = -Math.PI / 2;
    pouch.position.y = 0.38;
    pouch.castShadow = true;
    this.add(pouch);
    const label = labelPlane(['3.7V Li-Po', 'TEACHING SUPPLY'], 3.4, 1.35, { background: '#d9dee2', color: '#26313b', accent: '#ff4152' });
    label.rotation.x = -Math.PI / 2;
    label.position.y = 0.58;
    this.add(label);
    markInteractive(this, {
      id: 'battery', name: '聚合物锂电池', english: 'Li-Po Battery', model: '标称 3.7V',
      function: '为 VCC 与 GND 电源轨供电。',
      connection: '红线正极接 VCC，黑线负极接 GND。',
      mistake: '电源极性接反；实际电池满电电压高于 3.7V。',
      tip: '74HC 系列可在较宽电压范围工作。本项目仅为教学仿真，不替代电气安全设计。'
    });
  }
}
